import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/Navbar';
import Footer from '../../home/components/Footer';

export default function ElectricianChorleywood() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    { name: 'Electrical Installations', icon: '⚡', link: '/services/installations/electrical-installations' },
    { name: 'Full & Partial Rewiring', icon: '🔌', link: '/services/installations/rewiring' },
    { name: 'Consumer Unit Upgrades', icon: '🔧', link: '/services/installations/consumer-unit-upgrades' },
    { name: 'EV Charger Installation', icon: '🚗', link: '/services/installations/ev-charger' },
    { name: 'EICR Testing', icon: '📋', link: '/services/safety-compliance/eicr-testing' },
    { name: 'Fault Finding & Repairs', icon: '🔍', link: '/services/repairs/fault-finding' },
    { name: 'Lighting Installation', icon: '💡', link: '/services/installations/lighting-installation' },
    { name: 'Smart Home Systems', icon: '🏠', link: '/services/installations/smart-home' },
    { name: 'Emergency Callouts', icon: '🚨', link: '/services/repairs/emergency-callouts' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628] via-[#0F2847] to-[#0A1628]"></div>
        <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/9aceb8bc58e6775bdf1150449e386e1e.jpg')] bg-cover bg-center opacity-10"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
            <div className="flex items-center gap-2 bg-[#FFD700]/20 border border-[#FFD700] text-[#FFD700] px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-shield-check-fill"></i>
              NICEIC Approved
            </div>
            <div className="flex items-center gap-2 bg-[#FFD700]/20 border border-[#FFD700] text-[#FFD700] px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-map-pin-fill"></i>
              Local to Chorleywood
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Local Electrician Services<br />
            <span className="text-[#FFD700]">in Chorleywood</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
            Expert electrical services specifically for Chorleywood homes and businesses. NICEIC approved contractors delivering quality workmanship and reliable service with 15 years of experience.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:02031981818"
              className="w-full sm:w-auto bg-[#FFD700] text-[#0A1628] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#FFC700] transition-all duration-300 shadow-xl shadow-[#FFD700]/30 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              020 3198 1818
            </a>
            <a
              href="/#contact"
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#0A1628] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-fill"></i>
              Free Quote
            </a>
          </div>
        </div>
      </section>

      {/* Services in Chorleywood */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] mb-4">
              Services in Chorleywood
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive electrical solutions tailored to Chorleywood properties, from period homes to modern developments
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.link}
                className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FFD700] rounded-xl text-2xl flex-shrink-0">
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#0A1628] mb-2">{service.name}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0A1628] to-[#0F2847]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
              Why Choose Beyond Electrical?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Your trusted electrician in Chorleywood
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white/5 backdrop-blur-sm border border-[#FFD700]/30 rounded-2xl p-6 text-center">
              <div className="text-4xl mb-3">🏆</div>
              <h3 className="text-xl font-bold text-white mb-2">15 Years Experience</h3>
              <p className="text-gray-300 text-sm">
                Serving Chorleywood since 2009
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-[#FFD700]/30 rounded-2xl p-6 text-center">
              <div className="text-4xl mb-3">✅</div>
              <h3 className="text-xl font-bold text-white mb-2">NICEIC Approved</h3>
              <p className="text-gray-300 text-sm">
                Fully certified and insured
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-[#FFD700]/30 rounded-2xl p-6 text-center">
              <div className="text-4xl mb-3">⚡</div>
              <h3 className="text-xl font-bold text-white mb-2">Same Day Service</h3>
              <p className="text-gray-300 text-sm">
                Fast response in Chorleywood
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-[#FFD700]/30 rounded-2xl p-6 text-center">
              <div className="text-4xl mb-3">💯</div>
              <h3 className="text-xl font-bold text-white mb-2">Fixed Pricing</h3>
              <p className="text-gray-300 text-sm">
                No hidden costs or surprises
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Areas Covered */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0A1628] mb-6">
            Areas We Cover Around Chorleywood
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto">
            Professional electrical services throughout Chorleywood and surrounding areas
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {['Chorleywood', 'Watford', 'Rickmansworth', 'Moor Park', 'Northwood', 'Croxley Green', 'Abbots Langley', 'Kings Langley', 'Bushey', 'Radlett', 'Borehamwood', 'Hertfordshire'].map((area) => (
              <span
                key={area}
                className="bg-gradient-to-r from-[#FFD700] to-[#FFC700] text-[#0A1628] px-5 py-2.5 rounded-full font-semibold text-sm shadow-md"
              >
                {area}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#0A1628] via-[#0F2847] to-[#0A1628]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Need an Electrician in Chorleywood?
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-10 leading-relaxed">
            Contact us today for expert electrical services. Free quotes, fast response, and quality workmanship guaranteed.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:02031981818"
              className="w-full sm:w-auto bg-[#FFD700] text-[#0A1628] px-10 py-5 rounded-full font-bold text-lg hover:bg-[#FFC700] transition-all duration-300 shadow-2xl shadow-[#FFD700]/40 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              Call 020 3198 1818
            </a>
            <a
              href="/#contact"
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border-2 border-white text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-white hover:text-[#0A1628] transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-fill text-xl"></i>
              Get Free Quote
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}